export const CLOUDFLARE_STATUS = 'CLOUDFLARE_STATUS';
export const FASTLY_STATUS = 'FASTLY_STATUS';
export const LOG_UPLOADS = 'LOG_UPLOADS';
export const LOG_UPLOAD = 'LOG_UPLOAD';
